import newsfeedDescriptionWidgetUrl from './newsfeed-description-widget.html';
export default {
  controller: NewsfeedDescriptionWidgetCtrl,
  controllerAs: 'ctrl',
  bindings: {
    page: '<',
  },
  templateUrl: newsfeedDescriptionWidgetUrl,
};

function NewsfeedDescriptionWidgetCtrl($scope, focus, Authentication, NewsfeedCollection) {
  'ngInject';

  const controller = this;

  controller.$onInit = $onInit;
  controller.$onChanges = $onChanges;
  controller.addDescription = addDescription;
  controller.saveDescription = saveDescription;
  controller.editDescription = editDescription;
  controller.cancelEditDescription = cancelEditDescription;
  controller.canManagePage = canManagePage;

  let _prevDescription;

  function $onInit() {
    controller.editingDescription = false;
  }

  function $onChanges() {
    controller.canPostArticle = NewsfeedCollection.canPostArticle(this.page, Authentication.user);
    controller.employeeCanActOnPage = NewsfeedCollection.employeeCanActOnPage(
      this.page,
      Authentication.user
    );
  }

  function addDescription() {
    _prevDescription = controller.page.description;
    controller.page.description = '';
    controller.editingDescription = true;
    _setFocus();
  }

  function editDescription() {
    _prevDescription = controller.page.description;
    controller.editingDescription = true;
    _setFocus();
  }

  async function saveDescription() {
    try {
      const promise = await controller.page.put();
      controller.editingDescription = false;
      return promise;
    } catch (e) {
      controller.cancelEditDescription();
      throw e;
    }
  }

  function cancelEditDescription() {
    controller.page.description = _prevDescription;
    controller.editingDescription = false;
  }

  function _setFocus() {
    $scope.$evalAsync(() => {
      focus('description');
    });
  }

  function canManagePage() {
    return Authentication.user.isManager || controller.page?.owner?.isMe;
  }
}
